const isVotingClosedAt = (now, votingEndTime) =>
  new Date(now).getTime() >= new Date(votingEndTime).getTime()

export { isVotingClosedAt }
